var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.166 1.667c.46 0 .834.373.834.833v3.333h2.5c.46 0 .833.374.833.834V15c0 .46-.373.833-.833.833H15V17.5c0 .46-.373.833-.834.833H5.833A.833.833 0 0 1 5 17.5v-1.667H2.5A.833.833 0 0 1 1.667 15V6.667c0-.46.373-.834.833-.834H5V2.5c0-.46.373-.833.833-.833h8.334Zm-.833 12.5H6.666v2.5h6.667v-2.5ZM16.666 7.5H3.333v6.667H5v-.834c0-.46.373-.833.833-.833h8.334c.46 0 .833.373.833.833v.834h1.666V7.5Zm-10 .833V10h-2.5V8.333h2.5Zm6.667-5H6.666v2.5h6.667v-2.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.a24327e4c7a41a29abfee4f5b944d6bc.svg";
export { ForwardRef as ReactComponent };